import React, { useState } from 'react'
import styled from 'styled-components'
import { Box, Text } from 'grommet'
import { Download } from 'grommet-icons'
import { rgba } from 'polished'
import { toPng } from 'html-to-image'
import { browserName } from 'react-device-detect'

import History from './history'
import Score from './score'
import TipDrop from '../../Button/TipDrop'
import PageLogo from '../../Logo/PageLogo'

const DownloadAbsoluteBox = styled(Box)`
  display: ${props => (!props.downloading ? 'flex' : 'none')};
  position: absolute;
  left: 1.4rem;
  top: 1.4rem;
`

const Container = styled(Box)`
  z-index: 10;
  position: absolute;
  width: 100%;
  min-height: 100%;
  height: ${props => (!props.downloading ? '100%' : 'auto')};
  /* height: auto; */
  top: 0;
  left: 0;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  color: ${props => props.theme.global.colors.whiteText};
`

const Tab = styled(Box)`
  cursor: pointer;
`

const TabText = styled(Text)`
  /* font-size: 1.6rem; */
  user-select: none;
  color: ${props =>
    rgba(props.theme.global.colors.white, props.active ? 1.0 : 0.6)};
  font-weight: ${props => (props.active ? 700 : 400)};
`

const Separator = styled.hr`
  background-color: transparent;
  border-top: ${props => (props.active ? '3px' : '1px')} solid
    ${props => rgba(props.theme.global.colors.white, props.active ? 1.0 : 0.6)};
  margin-top: ${props => (props.active ? '.6rem' : '.7rem')};
  width: 100%;
  margin-bottom: 0.8rem;
`

const ContentBox = styled(Box)`
  flex: 1;
`

const AllResults = ({ history, choices, showLogo }) => {
  const [tabIndex, setTabIndex] = useState(0)
  const [downloading, setDownloading] = useState(false)

  let showScore = false
  let showDownload = false
  if (tabIndex === 0 && history.length > 0) {
    showDownload = true
  }
  if (choices.filter(item => item.count > 0).length > 0) {
    showScore = true
    if (tabIndex === 1) {
      showDownload = true
    }
  }

  const saveAsImage = () => {
    setDownloading(true)
    setTimeout(() => {
      toPng(document.getElementById('all-results-board')).then(function (
        first,
      ) {
        toPng(document.getElementById('all-results-board')).then(function (
          dataUrl,
        ) {
          var link = document.createElement('a')
          link.download = 'Picker-Wheel-Result.png'
          link.href = dataUrl
          link.click()
          setDownloading(false)
        })
      })
    }, 30)
  }

  return (
    <Container
      background="rgba(34, 34, 34, 0.8)"
      round="2rem"
      align="center"
      pad="1.5rem"
      id="all-results-board"
      downloading={downloading}
    >
      {browserName !== 'WebKit' && showDownload && (
        <TipDrop content="Download as Image" position="bottom">
          <DownloadAbsoluteBox onClick={saveAsImage} downloading={downloading}>
            <Download size="xsmall" color="white" />
          </DownloadAbsoluteBox>
        </TipDrop>
      )}
      <ContentBox width="43rem">
        <Box direction="row" justify="center">
          <Tab width="50%" align="center" onClick={() => setTabIndex(0)}>
            <TabText active={tabIndex === 0}>ALL RESULTS</TabText>
            <Separator active={tabIndex === 0} />
          </Tab>
          {showScore && (
            <Tab width="50%" align="center" onClick={() => setTabIndex(1)}>
              <TabText active={tabIndex === 1}>Score</TabText>
              <Separator active={tabIndex === 1} />
            </Tab>
          )}
        </Box>
        {tabIndex === 0 && <History history={history} />}
        {tabIndex === 1 && <Score choices={choices} />}
        {showLogo && <PageLogo page="emb" />}
      </ContentBox>
    </Container>
  )
}

export default AllResults
